import React from 'react';

export const Order: React.FC = ({ children }) => <span className="a-order">{children}</span>;
